/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmPersonCreateModal_CreateCrmPersonMutationVariables = Types.Exact<{
  input: Types.CreateCrmPersonInput;
}>;


export type CrmPersonCreateModal_CreateCrmPersonMutation = { createCrmPerson: { __typename: 'CreateCrmPersonResult', crmPerson: { __typename: 'CrmPerson', id: string, fullname: string, email: any } } };


export const CrmPersonCreateModal_CreateCrmPersonDocument = gql`
    mutation CrmPersonCreateModal_CreateCrmPerson($input: CreateCrmPersonInput!) {
  createCrmPerson(input: $input) {
    crmPerson {
      id
      fullname
      email
    }
  }
}
    `;
export type CrmPersonCreateModal_CreateCrmPersonMutationFn = Apollo.MutationFunction<CrmPersonCreateModal_CreateCrmPersonMutation, CrmPersonCreateModal_CreateCrmPersonMutationVariables>;

/**
 * __useCrmPersonCreateModal_CreateCrmPersonMutation__
 *
 * To run a mutation, you first call `useCrmPersonCreateModal_CreateCrmPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrmPersonCreateModal_CreateCrmPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crmPersonCreateModalCreateCrmPersonMutation, { data, loading, error }] = useCrmPersonCreateModal_CreateCrmPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmPersonCreateModal_CreateCrmPersonMutation(baseOptions?: Apollo.MutationHookOptions<CrmPersonCreateModal_CreateCrmPersonMutation, CrmPersonCreateModal_CreateCrmPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CrmPersonCreateModal_CreateCrmPersonMutation, CrmPersonCreateModal_CreateCrmPersonMutationVariables>(CrmPersonCreateModal_CreateCrmPersonDocument, options);
      }
export type CrmPersonCreateModal_CreateCrmPersonMutationHookResult = ReturnType<typeof useCrmPersonCreateModal_CreateCrmPersonMutation>;
export type CrmPersonCreateModal_CreateCrmPersonMutationResult = Apollo.MutationResult<CrmPersonCreateModal_CreateCrmPersonMutation>;
export type CrmPersonCreateModal_CreateCrmPersonMutationOptions = Apollo.BaseMutationOptions<CrmPersonCreateModal_CreateCrmPersonMutation, CrmPersonCreateModal_CreateCrmPersonMutationVariables>;